import { Inventory, Listing, Offer, OfferListing, TruckMaximums } from '../../../graphql/query-result-types';

export type MultiButtonType = React.FC<{
  primaryAction: {
    onClick: () => void;
    tooltipText: React.ReactElement | string;
  };
  primaryIcon: React.ElementType;
  actions?: {
    name: string;
    disabled: boolean;
    description: React.ReactElement | string;
  }[];
  disabled: boolean;
  loading: boolean;
  child: React.ReactElement;
  secondary: boolean;
  secondaryTooltipText: React.ReactElement | string;
  customActionClass?: string;
}>;

export interface OfferCardUser {
  _id: string;
  site: {
    truckMaximums?: TruckMaximums | null;
  };
}

export interface OfferCardActiveTrucklane {
  _id: string;
  totalRevenue: number;
  totalWeight: number;
  totalPallets: number;
}

export interface OfferCardOfferListing extends OfferListing {
  activeTruckLane: OfferCardActiveTrucklane;
  listing: Listing;
  offer: Offer;
}

export interface BackendError extends Error {
  code: string;
}

export enum OFFER_SHIFT_STATUS {
  ACCEPTED = 'ACCEPTED',
  PROPOSED = 'PROPOSED',
}

export interface OfferShiftForAcceptance {
  shiftedOfferListings: {
    shiftedInventoryId: string;
    pricePerCase: number;
    shiftedQuantity: number;
    logisticsOption: string;
    originalOfferId: string;
    id: string;
    shiftType: string;
    buyerUnitPrice?: number;
    unitPrice?: number;
    originalUnitPrice?: number;
    importedCurrencyUnitPrice?: number;
  }[];
  buyerSiteName: string;
}

export interface AcceptShiftedOfferListingsArgs {
  offerShifts: OfferShiftForAcceptance[];
}
export interface AcceptShiftedOfferListingsResponse {
  acceptShiftedOfferListings: {
    offerShifts: {
      _id: string;
      status: string;
      inventoryStatus: string;
    }[];
    errors?: {
      code: string;
      message: string;
    }[];
  };
}
interface OfferShift {
  _id: string;
  originalOfferListingId: string;
  shiftInventoryId: string;
  shiftedQuantity: number;
  status: OFFER_SHIFT_STATUS;
  unitPrice: number;
  buyerSiteId: string;
  shiftType: string;
  updatedAt: string;
  originalOfferListing: OfferListing;
}

export interface ProposedOfferShift extends OfferShift {
  status: OFFER_SHIFT_STATUS.PROPOSED;
  listing: Listing;
  shiftInventory: Inventory;
  newLogisticsRelationshipName: string;
  proposedTrucklaneId: string;
  shiftTrucklaneDistance: number;
  shiftTrucklaneCost: number;
  buyerSite: {
    _id: string;
    siteName: string;
  };
  activeTruckLane: {
    _id: string;
    totalRevenue: number;
    totalWeight: number;
    totalPallets: number;
  };
}

export interface AcceptedOfferShift extends OfferShift {
  status: OFFER_SHIFT_STATUS.ACCEPTED;
  newOfferListingId: string;
}

export type OfferCardOfferShift = AcceptedOfferShift | ProposedOfferShift;
